import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { loading, alert, format_date, getStorage, replaceText } from "./CustomComponent.js";

import "../assets/css/bootstrap.css";
import "./global.js";

// เรียกปิด loading ทันทีตั้งแต่เข้ามาโหลดหน้า/ไฟล์นี้
loading(false);

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
  FCIconic: { normal: "FCIconic-Light.ttf", bold: "FCIconic-Bold.ttf", italics: "FCIconic-Italic.ttf", bolditalics: "FCIconic-Italic.ttf" },
  THSarabunNew: { normal: "THSarabunNew.ttf", bold: "THSarabunNew-Bold.ttf", italics: "THSarabunNew-Italic.ttf", bolditalics: "THSarabunNew-BoldItalic.ttf" },
  Roboto: { normal: "Roboto-Regular.ttf", bold: "Roboto-Medium.ttf", italics: "Roboto-Italic.ttf", bolditalics: "Roboto-MediumItalic.ttf" },
};

async function print(docDefinition) {
  pdfMake.createPdf(docDefinition).print();
}

async function open(docDefinition, filename = "รายงาน.pdf") {
  try {
    pdfMake.createPdf(docDefinition).open();
  } catch (error) {
    pdfMake.createPdf(docDefinition).download(filename);
    if (error === "Open PDF in new window blocked by browser") {
      alert("warning", "แจ้งเตือน", "ไม่สามารถเปิดเอกสารได้เนื่องจากการปิดกั้นจากบราวเซอร์");
    } else {
      alert("warning", "แจ้งเตือน", "กรุณาลองใหม่อีกครั้ง");
    }
  }
}

// รายงานลูกค้าที่โอนกรรมสิทธิ์แล้ว
async function report_customer_1(data) {
  loading(true); // เปิด loading เริ่มประมวลผล PDF

  let array = data.map((item, index) => [
    { text: index + 1, alignment: "center" },
    { text: item.building || "-", alignment: "center" },
    { text: item.address_number || "-", alignment: "center" },
    { text: item.full_name || "-", alignment: "left" },
    { text: "โอนแล้ว", alignment: "center" },
    { text: item.transfer_date ? format_date(item.transfer_date) : "-", alignment: "center" },
    { text: "-", alignment: "left" },
  ]);

  const docDefinition = {
    content: [
      { text: `รายชื่อลูกค้าที่โอนกรรมสิทธิ์ห้องชุดแล้ว บันทึกโอนถึง วันที่ ${format_date(new Date(), "dd/mm/yyyy")}`, alignment: "center", fontSize: 18, bold: true },
      { text: getStorage("project_name") || "", alignment: "center", fontSize: 18, bold: true },
      { text: " " },
      {
        table: {
          headerRows: 1,
          widths: ["6%", "7%", "9%", "32%", "15%", "16%", "15%"],
          body: [
            [
              { text: "ลำดับ", alignment: "center" },
              { text: "อาคาร", alignment: "center" },
              { text: "บ้านเลขที่", alignment: "center" },
              { text: "ชื่อ - สกุล", alignment: "center" },
              { text: "สถานะ", alignment: "center" },
              { text: "วันโอนกรรมสิทธิ์", alignment: "center" },
              { text: "หมายเหตุ", alignment: "center" },
            ],
            ...array,
          ],
        },
      },
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 14, lineHeight: 0.9 },
    pageSize: "A4",
    pageMargins: [15, 15, 15, 15],
  };

  let textDocDefinition = await replaceText(docDefinition);
  
  loading(false); // ปิด loading เมื่อสร้างเสร็จพร้อมเปิดเอกสาร
  
  open(textDocDefinition, `รายชื่อลูกค้าที่โอนกรรมสิทธิ์ห้องชุดแล้ว บันทึกโอนถึง วันที่ ${new Date().toISOString()}.pdf`);
}

export { report_customer_1 };